import React, { createContext } from "react";
import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyC1hzQB1rEpP_3dwJjAVQK5ICPJc_BppsQ",
  authDomain: "uaps-app.firebaseapp.com",
  projectId: "uaps-app",
  storageBucket: "uaps-app.firebasestorage.app",
  messagingSenderId: "695236539277",
  appId: "1:695236539277:web:400a0de133afa5274443c4",
};
const app = initializeApp(firebaseConfig);

// `npm run start:emulated` talks to the local emulators (`npm run emulators`)
// instead of the live project.
if (process.env.REACT_APP_USE_EMULATORS === "true") {
  connectFirestoreEmulator(getFirestore(app), "127.0.0.1", 8080);
  connectStorageEmulator(getStorage(app), "127.0.0.1", 9199);
}

export const FirebaseAppContext = createContext();

export const FirebaseAppProvider = (props) => {
  return (
    <FirebaseAppContext.Provider value={app}>
      {props.children}
    </FirebaseAppContext.Provider>
  );
};
